import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom"; // Import useNavigate

// reactstrap components
import {
  Button,
  Card,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Container,
  Row,
  Col,
  Alert,
  Spinner
} from "reactstrap";

import IndexFooter from "components/Footers/IndexFooter.js";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";

// API endpoint for login
const API_URL = "https://api.pembrokefarmersmarket.ca/api/vendors/login"; // *** Adjust if your login endpoint is different ***

function LoginPage() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [feedback, setFeedback] = useState({ message: '', type: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    // Add a specific class for styling, similar to register page
    document.body.classList.add("register-page"); // Re-using register-page class for similar background/layout
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("register-page");
    };
  }, []);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFeedback({ message: '', type: '' });

    try {
      const response = await axios.post(API_URL, formData);
      // Assuming the API returns a token on successful login
      if (response.data && response.data.token) {
        localStorage.setItem("token", response.data.token); // Store the token
        setFeedback({ message: "✅ Login successful!", type: "success" });
        // Redirect to the profile page after a short delay
        setTimeout(() => {
           navigate("/profile-page"); // Navigate to profile page
        }, 1000); // 1 second delay
      } else {
         // Handle cases where login might succeed but no token is returned (if applicable)
         setFeedback({ message: "❌ Login successful, but no token received.", type: "warning" });
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Login failed. Please check your credentials.";
      setFeedback({ message: `❌ ${errorMessage}`, type: "danger" });
      console.error("Login error:", err.response || err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <IndexNavbar />
      <div
        className="page-header"
        style={{
          backgroundImage: "url(" + require("assets/img/login-image.jpg") + ")", // Same background as register
        }}
      >
        <div className="filter" />
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" lg="4">
              <Card className="card-register ml-auto mr-auto"> {/* Reusing card-register style */}
                <h3 className="title mx-auto">Vendor Login</h3>

                <Form className="register-form" onSubmit={handleSubmit}> {/* Reusing register-form class */}
                   {/* Display Feedback */}
                   {feedback.message && (
                    <Alert color={feedback.type} isOpen={!!feedback.message} toggle={() => setFeedback({ message: '', type: '' })} style={{fontSize: '0.85rem', padding: '0.5rem 1rem'}}>
                      {feedback.message}
                    </Alert>
                  )}

                  <FormGroup>
                    <Label for="loginEmail">Email</Label>
                     <InputGroup>
                       <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                             <i className="nc-icon nc-email-85" />
                          </InputGroupText>
                       </InputGroupAddon>
                        <Input
                          id="loginEmail"
                          name="email"
                          placeholder="Email"
                          type="email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          disabled={isSubmitting}
                        />
                     </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <Label for="loginPassword">Password</Label>
                     <InputGroup>
                       <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                             <i className="nc-icon nc-key-25" />
                          </InputGroupText>
                       </InputGroupAddon>
                        <Input
                          id="loginPassword"
                          name="password"
                          placeholder="Password"
                          type="password"
                          value={formData.password}
                          onChange={handleChange}
                          required
                          disabled={isSubmitting}
                        />
                     </InputGroup>
                  </FormGroup>

                  <Button block className="btn-round" color="danger" type="submit" disabled={isSubmitting}>
                     {isSubmitting ? <><Spinner size="sm" /> Logging In...</> : 'Login'}
                  </Button>
                </Form>
                 {/* Link to Register Page */}
                 <div className="text-center mt-3">
                  <p style={{ color: '#dcedcd', fontSize: '0.9rem' }}>
                    Not a vendor yet?{" "}
                    <Link to="/register-page" style={{ color: 'white', fontWeight: 'bold' }}>
                      Register here
                    </Link>
                  </p>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>      
      {/* Use the new IndexFooter component */}
      <IndexFooter />
    </>
  );
}

export default LoginPage;